"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IntrospectedCreateGuesser = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAdmin = require("react-admin");

var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));

var _finalFormSubmitErrors = require("final-form-submit-errors");

var _InputGuesser = _interopRequireDefault(require("./InputGuesser"));

var _Introspecter = _interopRequireDefault(require("./Introspecter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const displayOverrideCode = (schema, fields) => {
  if (process.env.NODE_ENV === 'production') return;
  let code = 'If you want to override at least one input, paste this content in the <CreateGuesser> component of your resource:\n\n';
  code += `const ${schema.title}Create = props => (\n`;
  code += `    <CreateGuesser {...props}>\n`;
  fields.forEach(field => {
    code += `        <InputGuesser source={"${field.name}"} />\n`;
  });
  code += `    </CreateGuesser>\n`;
  code += `);\n`;
  code += `\n`;
  code += `And don't forget update your <ResourceGuesser> component:\n`;
  code += `<ResourceGuesser name={"${schema.name}"} create={${schema.title}Create} />`;
  console.info(code);
};

const IntrospectedCreateGuesser = ({
  fields,
  readableFields,
  writableFields,
  schema,
  schemaAnalyzer,
  resource,
  basePath,
  onSuccess,
  successMessage,
  onFailure,
  redirect: redirectTo = 'list',
  initialValues,
  validate,
  toolbar,
  margin,
  variant,
  submitOnEnter,
  warnWhenUnsavedChanges,
  sanitizeEmptyValues,
  simpleFormComponent,
  children,
  ...props
}) => {
  const [mutate] = (0, _reactAdmin.useMutation)();
  const notify = (0, _reactAdmin.useNotify)();
  const redirect = (0, _reactAdmin.useRedirect)();
  const save = (0, _react.useCallback)(async values => {
    try {
      const response = await mutate({
        type: 'create',
        resource: resource,
        payload: {
          data: values
        }
      }, {
        returnPromise: true
      });
      const success = onSuccess ? onSuccess : ({
        data: newRecord
      }) => {
        notify(successMessage || 'ra.notification.created', 'info', {
          smart_count: 1
        });
        redirect(redirectTo, basePath, newRecord.id, newRecord);
      };
      success(response);
    } catch (error) {
      const submissionErrors = schemaAnalyzer.getSubmissionErrors(error);
      const failure = onFailure ? onFailure : error => {
        let message = 'ra.notification.http_error';

        if (!submissionErrors) {
          message = typeof error === 'string' ? error : error.message || message;
        }

        notify(message, 'warning', {
          _: typeof error === 'string' ? error : error && error.message ? error.message : undefined
        });
      };
      failure(error);

      if (submissionErrors) {
        return submissionErrors;
      }

      return {};
    }
  }, [mutate, resource, onSuccess, successMessage, onFailure, notify, redirect, redirectTo, basePath, schemaAnalyzer]);
  let inputChildren = children;

  if (!inputChildren) {
    inputChildren = writableFields.map(field => /*#__PURE__*/_react.default.createElement(_InputGuesser.default, {
      key: field.name,
      source: field.name
    }));
    displayOverrideCode(schema, writableFields);
  }

  return /*#__PURE__*/_react.default.createElement(_reactAdmin.Create, _extends({
    resource: resource,
    basePath: basePath
  }, props), /*#__PURE__*/_react.default.createElement(_reactAdmin.SimpleForm, {
    save: save,
    mutators: { ..._finalFormArrays.default,
      ..._finalFormSubmitErrors.submitErrorsMutators
    },
    initialValues: initialValues,
    validate: validate,
    toolbar: toolbar,
    margin: margin,
    variant: variant,
    submitOnEnter: submitOnEnter,
    warnWhenUnsavedChanges: warnWhenUnsavedChanges,
    sanitizeEmptyValues: sanitizeEmptyValues,
    component: simpleFormComponent
  }, /*#__PURE__*/_react.default.createElement(_finalFormSubmitErrors.SubmitErrorsSpy, null), inputChildren));
};

exports.IntrospectedCreateGuesser = IntrospectedCreateGuesser;

const CreateGuesser = props => /*#__PURE__*/_react.default.createElement(_Introspecter.default, _extends({
  component: IntrospectedCreateGuesser
}, props));

CreateGuesser.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  resource: _propTypes.default.string.isRequired
};
var _default = CreateGuesser;
exports.default = _default;